import React from 'react';

const AnalyticsModal = ({ onAccept, onDecline }) => {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: '#ffad63',
                color: '#fff',
                padding: '12px', // reduced from 20px
                boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                zIndex: 1000,
                flexWrap: 'wrap', // allows wrapping on smaller screens
            }}
        >
            <div style={{ maxWidth: '80%' }}>
                <h2 style={{ margin: 0, fontSize: '14px', color: "#343a40" }}>We use cookies</h2> {/* reduced from 20px */}
                <p style={{ margin: '3px 0', fontSize: '12px', color: "#343a40" }}>
                    We use cookies to enhance your browsing experience and analyze site traffic. By clicking
                    "Accept", you consent to the use of cookies.
                </p>
            </div>
            <div style={{ display: 'flex', gap: '6px' }}>
                <button
                    onClick={onAccept}
                    style={{
                        backgroundColor: '#00c853',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '3px',
                        padding: '6px 12px', // reduced from 10px 20px
                        cursor: 'pointer',
                        fontSize: '10px', // reduced from 14px
                    }}
                >
                    Accept
                </button>
                <button
                    onClick={onDecline}
                    style={{
                        backgroundColor: '#d32f2f',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '3px',
                        padding: '6px 12px',
                        cursor: 'pointer',
                        fontSize: '10px',
                    }}
                >
                    Decline
                </button>
            </div>
        </div>

    );
};

export default AnalyticsModal;
